var BaseViews = require('../../../base');
require('./menu-item-price/menu-item-price.scss');
var LAYOUT_TYPES = {
    STACKED: 'stacked',
    INLINE: 'inline',
    PROMOTION: 'promotion'
};
var OutOfStockSVG = BaseViews.ItemView.extend({
  template: function () {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43.05 7.17"><title>Asset 1</title><g id="Layer_2" data-name="Layer 2"><g id="art"><path d="M0,1.76A1.55,1.55,0,0,1,1.67,0,1.55,1.55,0,0,1,3.34,1.76V5.4A1.55,1.55,0,0,1,1.67,7.16,1.55,1.55,0,0,1,0,5.4ZM1.1,5.47c0,.5.22.69.57.69s.57-.19.57-.69V1.69C2.24,1.19,2,1,1.67,1s-.57.19-.57.69Z"/><path d="M5.3.08v5.4c0,.5.22.68.57.68s.57-.18.57-.68V.08h1V5.41c0,1.12-.56,1.76-1.64,1.76S4.2,6.53,4.2,5.41V.08Z"/><path d="M8.11.08h3.4v1H10.36v6H9.26v-6H8.11Z"/><path d="M13.85,1.76A1.55,1.55,0,0,1,15.52,0a1.55,1.55,0,0,1,1.67,1.76V5.4a1.55,1.55,0,0,1-1.67,1.76A1.55,1.55,0,0,1,13.85,5.4ZM15,5.47c0,.5.22.69.57.69s.57-.19.57-.69V1.69c0-.5-.22-.69-.57-.69s-.57.19-.57.69Z"/><path d="M19.2,3.19h1.42v1H19.2V7.08H18.1v-7H21v1H19.2Z"/><path d="M25,0C26,0,26.59.64,26.59,1.76V2h-1V1.69c0-.5-.2-.69-.55-.69s-.55.19-.55.69.22.89.94,1.52A2.71,2.71,0,0,1,26.6,5.4C26.6,6.52,26,7.16,25,7.16s-1.64-.64-1.64-1.76V5h1v.5c0,.5.22.68.57.68s.57-.18.57-.68-.22-.89-.94-1.52a2.71,2.71,0,0,1-1.21-2.19C23.35.64,23.9,0,25,0Z"/><path d="M27.11.08h3.4v1H29.36v6h-1.1v-6H27.11Z"/><path d="M31.1,1.76a1.67,1.67,0,1,1,3.34,0V5.4a1.67,1.67,0,1,1-3.34,0Zm1.1,3.71c0,.5.22.69.57.69s.57-.19.57-.69V1.69c0-.5-.22-.69-.57-.69s-.57.19-.57.69Z"/><path d="M38.54,4.47V5.4c0,1.12-.56,1.76-1.64,1.76s-1.64-.64-1.64-1.76V1.76C35.26.64,35.82,0,36.9,0s1.64.64,1.64,1.76v.68h-1V1.69c0-.5-.22-.69-.57-.69s-.57.19-.57.69V5.47c0,.5.22.68.57.68s.57-.18.57-.68v-1Z"/><path d="M40.85,4.29l-.34.64V7.08h-1.1v-7h1.1v3h0L42,.08h1.1L41.52,3.2l1.53,3.88H41.92Z"/></g></g></svg>';
  }
});

var OutOfStockLabel = BaseViews.ItemView.extend({
  template: function () {
    return 'OUT OF STOCK';
  },
  className: 'fmy-menu-item-out-of-stock-variation-label'
});

var MenuItemPriceLocationCheck = BaseViews.LayoutView.extend({
    className: 'fmcy-menu-item-price fmcy-menu-item-price-check',
    template: function (serializedData) {
      return require('./menu-item-price/menu-item-price-check.html')(serializedData);
    },
    ui: {
        priceQuantity: '.fmcy-menu-item-price-quantity',
        checkMark: '.fmcy-menu-item-price-quantity-check-mark'
    },
    regions: {
      fmcyOutOfStockIconRegion: '.fmcy-menu-item-price-quantity-out-of-stock-icon-region'
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                onlinePurchaseEnabled: false,
                layout: LAYOUT_TYPES.STACKED // stacked | inline | promotion
            }
        );
    },
    _isOnSale: function () {

      if (this.model.get('sale_price') === "0.00") {
        return false;
      } else {
        return !!this.model.get('sale_price') && this.model.get('on_sale');
      }
    },
    serializeData: function() {
        var onSale = this._isOnSale();
        var price = this.model.get(onSale ? 'sale_price' : 'price');
        var regularPrice = this.model.get(onSale ? 'price' : 'sale_price');
        return {
            options: this.options,
            quantity: this.model.get('quantity'),
            regularPrice: regularPrice,
            price: price,
            onSale: onSale,
            saved: onSale ? (regularPrice - price).toFixed(2) : ''
        };
    },
    _renderOutOfStockIcon: function () {
      var outOfStockIcon = new OutOfStockLabel();
      this.fmcyOutOfStockIconRegion.show(outOfStockIcon);
    },
    onRender: function () {
      var self = this;
        if (this._isOnSale()) {
            this.$el.addClass('fmcy-on-sale');
        }
        if (this.options.variantOutOfStockAtFilteredLocation === true) {
          this.ui.checkMark.hide();
          this._renderOutOfStockIcon();
        }

        var currentFilteredLocation = false;

        _.each(this.model.get('locations'), function (location) {
          if (location.location_id == self.options.locationId && self.options.appChannel.request('get:filter:location') === location.slug) {
            currentFilteredLocation = true;
          }
        });

        if (currentFilteredLocation === true) {
          this.$el.addClass('fmcy-menu-item-price-check-selected-location');
        }

        this.$el.addClass('fmcy-menu-item-price-layout-' + this.options.layout);

        BaseViews.ItemView.prototype.onRender.call(this);
    }
});
module.exports = MenuItemPriceLocationCheck;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/common/menu-item-prices/menu-item-price-location-check.js
 **/